export enum TeamQrCodeAccessType {
  Public,
  Pin ,
  Invite,
  Private
}
